import { ComponentItemWithData } from "../..";
import { ChartConfigHelper } from "../../helpers/chartConfigHelper";
import RenderErrorCard from "./RenderErrorCard";
import StatCard from "../StatsCard";

const RenderMetricCard = (component: ComponentItemWithData, index: number) => {
  const config = ChartConfigHelper.getMetricConfig(
    component.module,
    component.configKey
  );

  if (!config) return RenderErrorCard(component, index, "metric-card");

  const { value = 0, growth } = component.data || {};
  const trend =
    growth !== undefined ? (growth >= 0 ? "up" : "down") : undefined;
  const change =
    growth !== undefined ? `${growth >= 0 ? "+" : ""}${growth}%` : undefined;
  return (
    <>
      <div key={component.id} data-index={index}>
        <StatCard
          title={config.title}
          value={value}
          change={change}
          changeLabel="vs last period"
          trend={trend}
          icon={config.icon}
          description={config.description}
          variant={config.variant}
          module={component?.module}
          valueFormat={config?.valueFormat}
        />
      </div>
    </>
  );
};

export default RenderMetricCard;
